import PropTypes from 'prop-types'

import Snackbar from '@mui/material/Snackbar'
import CircularProgress from '@mui/material/CircularProgress'

const MayorLoader = ({ isVisible }) => {
  const anchorOrigin = {
    vertical: 'bottom',
    horizontal: 'right'
  }

  return (
    <Snackbar
      anchorOrigin={anchorOrigin}
      open={isVisible}
    >
      <CircularProgress
        size={35}
        color='primary'
        variant='indeterminate'
        sx={{ padding: 0 }}
      />
    </Snackbar>
  )
}

MayorLoader.propTypes = {
  isVisible: PropTypes.bool.isRequired
}

export default MayorLoader
